<template>
	<div class="oh systemManagement">
		<leftnav class=" fl" :curindex="6" :openmeun='true' :title="title" :openmeunclass='5'></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="index_left_centerpage whitebox" style="min-height: 95vh;">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="系统管理"></freeUserTips>
				</div>
			</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'systemManagement',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {}, title: "系统管理",
			checkList: ['系统管理'],
			jjframe: false,
			editframe: false,
			determine: false,
			addpartmentf: false,
			jjoptions: [],
			departmentoption: [],
			roleoption: [],
			latestOnlineTime: '',
			departmentvalue: '',
			rolevalue: '',
			options: [{
				value: '1',
				label: '黄金糕'
			}, {
				value: '2',
				label: '双皮奶'
			}, {
				value: '3',
				label: '蚵仔煎'
			}, {
				value: '4',
				label: '龙须面'
			}, {
				value: '5',
				label: '北京烤鸭'
			}],
			value: '',
			value1: '',
			input: '',
			systemdata: [
				// {id:1,name:"王强",city:"惠州市",phone:"151454573",department:"招商部",type:"普通用户",time:"2022-1-13 10:29",jurisdiction:"工作台,统计分析,跟进记录"}, 
				// {id:2,name:"王强",city:"惠州市",phone:"151454573",department:"招商部",type:"普通用户",time:"2022-1-13 10:29",jurisdiction:"工作台,统计分析,跟进记录"},
				// {id:3,name:"王强",city:"惠州市",phone:"151454573",department:"招商部",type:"普通用户",time:"2022-1-13 10:29",jurisdiction:"工作台,统计分析,跟进记录"},
			],
			checkAll: false,  //判读是否全选
			ischeckedlist: [], //复选框选中列表id
			cheksysdata: [],
			editname: '',    //编辑用户弹窗的真名（可以和用户名不一样）
			ediedepartname: '', //编辑用户弹窗的所属部门
			editrole: '',   //编辑用户弹窗的用户权限id 
			editauthority: '', //编辑用户弹窗的用户权限 已隐藏
			addusername: '', //添加用户弹窗的用户名
			addpwd: '', //添加用户弹窗的用户密码
			adddepartment: '', //添加用户弹框的所属部门
			addrole: '',   //添加用户弹窗的用户id
			addrealname: '', //添加用户弹窗的用户名
			nsysdata: {}, //用来存储筛选后的数据 
			departmentname: '',//添加部门弹窗的部门名称
			erromsg: '',

		}
	},
	// watch: {//深度 watcher
	//   'checkAll': {
	//     handler (val, oldVal) { 
	// 					console.log("checkall");
	//       if (this.ischeckedlist.length === this.systemdata.length) {
	// 							console.log("true");
	//         this.checkAll=true;	
	//       }else{
	// 							console.log("false");
	//         this.checkAll=false;
	//       }
	//     },
	//     deep: true
	//   }
	// },
	watch: {//深度 watcher 列表是否所有选中，选中则全选按钮勾选
		'ischeckedlist': {
			handler(val, oldVal) {
				// console.log("ischeckedlist");
				if (this.ischeckedlist.length === this.nsysdata.length) {
					console.log("checkAlltrue");
					this.checkAll = true;
				} else {
					console.log("checkAllfalse");
					this.checkAll = false;
				}
			},
			deep: true
		}
	},
	created() {
	},
	mounted() {
	},
	methods: {
		//用户列表
		getajasdata() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.user.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("用户列表", res);
				if (res.data.success) {
					_this.systemdata = res.data.list;
					_this.nsysdata = _this.systemdata;
					var noption = res.data.list;
					console.log('23', noption);
					for (var i = 0; i < noption.length; i++) {
						noption[i].label = noption[i].userName;
						noption[i].value = noption[i].id;
					}
					console.log('3213', noption);
					_this.jjoptions = noption;

					_this.getdepartmentlist();
					_this.getrole();
					_this.bus.$emit('loading', false);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//格式化日期 （时间戳）
		dateFormat(dateData) {
			var date = new Date(dateData)
			var M = date.getMonth() + 1
			M = M < 10 ? ('0' + M) : M
			var y = date.getFullYear()
			var d = date.getDate()
			d = d < 10 ? ('0' + d) : d
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds()
			this.latestOnlineTime = y + '-' + M + '-' + d
			//+ ' '+ h + ':'+ m+ ':'+ s 
			console.log(this.latestOnlineTime);
			return this.latestOnlineTime;
		},
		//获取部门列表
		getdepartmentlist() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.department.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("部门列表", res);
				if (res.data.success) {
					var ndepartmentlist = res.data.list;
					for (var i = 0; i < ndepartmentlist.length; i++) {
						ndepartmentlist[i].label = ndepartmentlist[i].name;
						ndepartmentlist[i].value = ndepartmentlist[i].id;
					}
					_this.departmentoption = ndepartmentlist;
					// _this.departmentoption.push({label:"全公司",value:0});
					console.log('1111', _this.departmentoption);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//筛选
		infofilter(data) {
			console.log('data:', data);
			if (this.input != '') {
				this.nsysdata = data.filter(data => {
					// console.log(this.input,data.userName.indexOf(this.input)==0);
					return data.userName.indexOf(this.input) == 0;
				});
			} else { this.nsysdata = data }
			if (this.departmentvalue != "") {
				this.nsysdata = data.filter(data => {
					return data.departmentId == this.departmentvalue;
				});
			}
			if (this.rolevalue != '') {
				this.nsysdata = data.filter(data => {
					return data.roleType == this.rolevalue;
				});
			}
			if (this.latestOnlineTime) {
				var ntime = '';
				this.nsysdata = data.filter(data => {
					var ltime = data.latestOnlineTime;
					ntime = ltime.substring(0, 10)
					return ntime.indexOf(this.latestOnlineTime) == 0;
				});
			}
			console.log('nsysdata', this.nsysdata);
		},
		// 获取角色列表
		getrole() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.role.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("角色列表", res);
				if (res.data.success) {
					var nroleoption = res.data.list;
					for (var i = 0; i < nroleoption.length; i++) {
						nroleoption[i].label = nroleoption[i].roleName;
						nroleoption[i].value = nroleoption[i].id;
					}
					_this.roleoption = nroleoption;
					console.log('1111', _this.roleoption);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//用户交接
		jjrchange(fromid, toid) {
			var _this = this;
			var nfromid = '';
			for (var j = 0; j < fromid.length; j++) {
				nfromid = fromid[j];
			}
			nfromid = parseInt(nfromid);
			console.log('22222', typeof nfromid);
			$.ajax({
				type: "POST",
				url: this.$api.crm.user.transfer(),
				data: { from: nfromid, to: toid },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					console.log(11111, nfromid, toid);
					if (res.success) {
					}
				}
			})
		},
		//编辑用户信息
		edit() {
			var _this = this;
			console.log(this.editname, this.ediedepartname, _this.editrole);
			if (this.editname == undefined || this.ediedepartname == undefined || this.editrole == undefined) {
				if (this.editname == undefined) {
					this.erromsg = '姓名不能为空';
				} else if (this.ediedepartname == undefined) {
					this.erromsg = '请选择部门';
				} else if (this.editrole == undefined) {
					this.erromsg = "请选择角色"
				}
				// return;
			}

			$.ajax({
				type: "POST",
				url: this.$api.crm.user.update(),
				data: { userId: _this.cheksysdata.id, realName: _this.editname, departmentId: _this.ediedepartname, roleId: _this.editrole, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.cheksysdata.realName = _this.editname;
						_this.cheksysdata.departmentName = _this.ediedepartname;
						_this.cheksysdata.roleType = _this.editrole;
						_this.editframe = false;
						_this.getajasdata();
					}
				}
			})
			// console.log(this.editname,this.ediedepartname,this.editrole,this.editauthority)
		},
		//添加用户
		adduser() {
			var _this = this;
			console.log(this.addusername, this.addpwd, this.addrealname, 'buem', this.adddepartment, 'jies', this.addrole);
			if (this.addusername == "" || this.addpwd == '' || this.addrealname == '' || this.adddepartment == '' || this.addrole == '') {
				if (this.addusername == '') {
					this.erromsg = '用户名不能为空';
				} else if (this.addpwd == '') {
					this.erromsg = '密码不能为空';
				} else if (this.addrealname == '') {
					this.erromsg = "姓名不能为空"
				} else if (this.adddepartment == '') {
					this.erromsg = "请选择部门"
				} else if (this.addrole == '') {
					this.erromsg = "请选择角色"
				}
				// return;
			}
			$.ajax({
				type: "POST",
				url: this.$api.crm.user.add(),
				data: { userName: _this.addusername, password: _this.addpwd, realName: _this.addrealname, departmentId: _this.adddepartment, roleId: _this.addrole },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.getajasdata();
						_this.determine = false;
					}
				}
			})
		},

		//赋值判断
		pdfun() {
			if (this.ischeckedlist.length == 1) {
				this.editframe = true;
				this.editname = this.cheksysdata.realName;
				this.ediedepartname = this.cheksysdata.departmentName;
				this.editrole = this.cheksysdata.roleType;
			} else {
				alert('一次只能编辑一个用户信息');
			}

		},

		//对数据进行ceked赋值，
		cha() {
			var sysdata = this.nsysdata;
			for (var i = 0; i < sysdata.length; i++) {
				sysdata[i].isceked = false;
				for (var j = 0; j < this.ischeckedlist.length; j++) {
					if (sysdata[i].id == this.ischeckedlist[j]) {
						sysdata[i].isceked = true;
						if (sysdata[i].isceked == true) {
							this.cheksysdata = sysdata[i];
						}
						console.log('cheksysdata', this.cheksysdata);
					}
				}
			}
		},
		//全选反选
		checkedall() {
			var newischeckedlist = [];
			if (this.checkAll) {
				// console.log(111);
				this.ischeckedlist = [];
			} else {
				for (var i = 0; i < this.nsysdata.length; i++) {
					newischeckedlist.push(this.nsysdata[i].id);
					// console.log('newischeckedlist',newischeckedlist);
					this.ischeckedlist = newischeckedlist;
					console.log('ischeckedlist', this.ischeckedlist);
				}
			}
		},
		//添加部门
		adddepartmentfun() {
			if (this.departmentname == '') {
				alert('部门名称不能为空');
			}
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.department.add(),
				data: { departmentId: 0, name: _this.departmentname },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.getdepartmentlist();
						_this.addpartmentf = false;
					}
				}
			})
		},
	}
}
</script>

<style></style>
